// Startsiden: ansatte, ledere og administratorer lander på Min side når de
// åpner appen på forsiden (etter innlogging, fra hjemskjermen eller ved
// omlasting). Bare første gang per bruker i denne innlastingen av appen:
// klikker de «Dashboard» etterpå, får de dashboardet. Åpner de en direktelenke,
// havner de der. Kunder og medarbeidere har egne rutegrupper og berøres ikke.
//
// Hvem som har landet, holdes i minnet. En omlasting er en ny innlasting.

const landet = new Set()

/** Rollene som lander på Min side. Andre (og nye) roller lander på dashboardet. */
export const ROLLER_TIL_MIN_SIDE = new Set(['ansatt', 'leder', 'administrator'])

/** Nøkkelen for brukeren: appUserId fra /auth/me, som er den viste brukeren også i «Se som». */
export const brukernokkel = appUser => appUser?.appUserId || appUser?.email || null

/** Kalles når brukeren har sett en side, uansett hvilken. */
export function markerLandet(nokkel) {
  if (nokkel) landet.add(nokkel)
}

/**
 * Skal forsiden sende brukeren til Min side? Bare for rollene over, og bare når
 * de kan se Min side; uten tilgangen ville Min side sendt dem tilbake hit.
 */
export function tilMinSide({ rolle, nokkel, kanSeMinSide }) {
  return ROLLER_TIL_MIN_SIDE.has(rolle) && Boolean(kanSeMinSide) && Boolean(nokkel) && !landet.has(nokkel)
}

/** Bare for testene. */
export function glemLandinger() {
  landet.clear()
}
